





































































































import {
  ref,
  defineComponent,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import { useActions, useGetters } from "vuex-composition-helpers";
import { useInputRules } from "@/ts/functions/composition/inputRules";
import ImageInput from "@c/molecules/media/ImageInput.vue";
import TagsInput from "@c/molecules/tag/TagsInput.vue";
import CaldateInput from "@c/molecules/input/CaldateInput.vue";
import BackButton from "@c/atoms/app/BackButton.vue";
import CudLayout from "@/vue/layouts/crud/CudLayout.vue";
import VisibilityInput from "@c/molecules/input/VisibilityInput.vue";
import ProjectModel from "@/ts/models/projectClass";

export default defineComponent({
  name: "ProjectCreation",

  components: {
    ImageInput,
    TagsInput,
    CaldateInput,
    BackButton,
    CudLayout,
    VisibilityInput
  },

  setup(props, { root }) {
    const { lastRoute } = useGetters({ lastRoute: "app/lastRoute" } as any);

    const rules = useInputRules();

    const { SEND_PROJECT_CREATION } = useActions({
      SEND_PROJECT_CREATION: "project/SEND_PROJECT_CREATION"
    } as any);

    var place_id = ref(root.$route.params.place_id);
    var form = ref(false);
    var loading = ref(false);
    var newProject = ref(new ProjectModel({ place_id: place_id.value }));

    const createProject = () => {
      loading.value = true;
      SEND_PROJECT_CREATION(newProject.value)
        .then(() => {
          loading.value = false;
          root.$router.push(
            "/place/" + newProject.value.place_id + "/projects"
          );
        })
        .catch(() => {
          loading.value = false;
        });
    };
    const updateTags = (tags: any) => {
      newProject.value.tags = tags;
    };

    return {
      form,
      rules,
      loading,
      newProject,
      createProject,
      lastRoute
    };
  }
});
